<template>
  <v-container fluid color="white--text">
    <v-card elevation="5">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-card flat>
              <v-card-text>
                <h3>Business to Customer (B2C)</h3>
                <p>
                  As a SasaPay merchant, you can send money to your customers through various channel. B2C API is applicable in various use cases such as Salary Payments, Promotional Payments(e.g. winning betting payouts), winnings, financial institutions withdrawal of funds, loan disbursements etc.
                </p>
              </v-card-text>
              <v-divider/>
              <v-card-text>
                EndPoints:<br/>
                <div class="secondary ma-4" style="color: #e7e3fc">
                  <strong>Sandbox</strong>
                  <p class="ma-2">{{"https://sandbox.sasapay.app/api/v1/payments/b2c/"}}</p>
                </div>
              </v-card-text>
              <v-divider/>
              <v-card-text>
                Request Parameters <br/>

                <v-icon color="primary">mdi-access-point-check</v-icon> <code>MerchantCode</code>:  A unique number assigned to an organization/Merchant <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>MerchantTransactionReference</code>:  A unique identifier of the transaction generated by the Merchant system.<br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>Amount</code>:  &nbsp;Amount to be sent. <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>Currency</code>: &nbsp;  Currency (KES)<br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>ReceiverNumber</code>:   &nbsp;  Where money is sent to<br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>Channel</code>: Where money is transferred to.<br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>Reason</code>:  The reason for payment.. <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>CallBackURL</code>:  URL to receive payment results <br/>

              </v-card-text>
              <v-divider/>
              <v-card-text>
                Expected Results:<br/>

                Sasa<span class="red--text">Pay</span> returns the status code & a detailed message
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" class="">
            <h3>Sample Request</h3>
            <code-editor
                :read_only="true"
                theme="dark"
                v-model="code"
                @lang="changeLanguage"
                :wrap_code="false"
                :language_selector="true"
                class="github_dark"
                :copy_code="true"
                font_size="14px"
                width="100%"
                :languages="[['php','PHP'],['java','Java'],['python', 'Python'],['go','Go'],['csharp','C#'],['javascript', 'Node Js']]"
            ></code-editor>
            <v-divider/>
            <h3>Sample Response</h3>
            <code-editor
                :read_only="true"
                theme="dark"
                v-model="response"
                :wrap_code="false"
                :language_selector="true"
                class="github_dark"
                :copy_code="true"
                font_size="14px"
                width="100%"
                :languages="[['json','JSON']]"
            ></code-editor>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--BEGIN B2B-->
    <v-card elevation="5" class="mt-5">
      <v-card-text>
        <v-row class="mt-5">
          <v-divider/>
          <v-col cols="12" md="6">
            <v-card flat>
              <v-card-text>
                <h3>Business to Business (B2B)</h3>
                <p>
                  Transact between SasaPay Biller number to another Biller number registered on SasaPay
                </p>
              </v-card-text>
              <v-divider/>
              <v-card-text>
                EndPoints:<br/>
                <div class="secondary" style="color: #e7e3fc">
                  <strong>Sandbox</strong>
                  <p class="ma-5">{{"https://sandbox.sasapay.app/api/v1/payments/b2b/"}}</p>
                </div>
              </v-card-text>
              <v-divider/>
              <v-card-text>
                Request Parameters <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>MerchantCode</code>:  A unique number assigned to an organization/Merchant <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>MerchantTransactionReference</code>:  A unique identifier of the transaction generated by the Merchant system.<br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>Amount</code>:  &nbsp;Amount to be sent. <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>Currency</code>: &nbsp;  Currency (KES)<br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>ReceiverMerchantCode</code>:   &nbsp;  This is the merchant code where the funds are to be received.<br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>Channel</code>: Where money is transferred to.<br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>Reason</code>:  The reason for payment.. <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>CallBackURL</code>:  URL to receive payment results <br/>

              </v-card-text>
              <v-divider/>
              <v-card-text>
                Expected Results:<br/>

                Sasa<span class="red--text">Pay</span> returns the status code & a detailed message
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" class="">
            <h3>Sample Request</h3>
            <code-editor
                :read_only="true"
                theme="dark"
                v-model="b2bCode"
                :wrap_code="false"
                :language_selector="true"
                @lang="changeB2BLanguage"
                class="github_dark"
                :copy_code="true"
                font_size="14px"
                width="100%"
                :languages="[['php','PHP'],['java','Java'],['python', 'Python'],['go','Go'],['csharp','C#'],['javascript', 'Node Js']]"
            ></code-editor>
            <v-divider/>
            <h3>Sample Response</h3>
            <code-editor
                :read_only="true"
                theme="dark"
                v-model="b2bResponse"
                :wrap_code="false"
                :language_selector="true"
                class="github_dark"
                :copy_code="true"
                font_size="16px"
                width="100%"
                :languages="[['json','JSON']]"
            ></code-editor>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <ScrollDownIcon/>
    <!--END B2B-->
  </v-container>
</template>

<script>

import {getB2CRequest, getB2CResponse} from "../../../../../shared/snippets/b2c/b2c";
import {getB2BRequest, getB2BResponse} from "../../../../../shared/snippets/b2c/b2c";
import ScrollDownIcon from "../../../../../shared/scroller/ScrollDownIcon.vue";

export default {
  name: "B2C",
  components: {ScrollDownIcon},
  // components: { VueStylelintEditor },
  data: () =>({
    selectedLanguage:"",
    b2bCode:"",
    code:"",
    response:"",
    b2bResponse:"",
  }),
  mounted() {
    this.importSnippets('php')//
    this.importResponse()
    //
    this.importB2BSnippets('php')
    this.importB2BResponse()
  },
  methods:{
    importSnippets(lang){
      this.code=getB2CRequest(lang)
    },
    importResponse(){
      this.response=getB2CResponse()
    },
    changeLanguage(val) {
      this.importSnippets(val)
    },
    //b2b
    importB2BSnippets(lang){
      this.b2bCode=getB2BRequest(lang)
    },
    importB2BResponse(){
      this.b2bResponse=getB2BResponse()
    },
    changeB2BLanguage(val) {
      this.importB2BSnippets(val)
    }
  }
}
</script>

<style scoped>

</style>
